import { IRecommendationState } from './IRecommendationState';
import { McAction } from '../../IMcAction';

// recommendationCount
export function updateRecommendationCount(state: IRecommendationState, action: { recommendationCount }): IRecommendationState {
    return Object.assign({}, state, {
        recommendationCount: action.recommendationCount
    });
}

export function reset(state: IRecommendationState, action: { recommendationCount }): IRecommendationState {
    return Object.assign({}, state, {
        recommendationCount: 0
    });
}

// recommendations
export function populateRecommendations(state: IRecommendationState, action: McAction): IRecommendationState {
    return Object.assign({}, state, {
        recommendations: action.payload
    });
}

export function setSelectedStudyTestRecommendation(state: IRecommendationState, action: McAction): IRecommendationState {
    return Object.assign({}, state, {
        selectedStudyTestRecommendation: action.payload
    });
}

export function setSelectedRecommendation(state: IRecommendationState, action: McAction): IRecommendationState {
    return Object.assign({}, state, {
        selectedRecommendation: action.payload
    });
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/recommendation/recommendation.reducer.logic.ts